/**
 * Form Constants
 * Centralized form options and default values
 */

export const JENIS_KELAMIN_OPTIONS = [
  { value: "Laki-laki", label: "Laki-laki" },
  { value: "Perempuan", label: "Perempuan" },
];

export const LAYANAN_OPTIONS = [
  { value: "PEN", label: "Front Office/Pendaftaran" },
  { value: "FARM", label: "Farmasi" },
  { value: "RAD", label: "Radiologi" },
  { value: "LAB", label: "Laboratorium" },
];

export const RATING_LABELS = {
  keramahan: [
    "Sangat Tidak Ramah",
    "Tidak Ramah",
    "Cukup Ramah",
    "Ramah",
    "Sangat Ramah",
  ],
  kejelasanInformasi: [
    "Sangat Tidak Jelas",
    "Tidak Jelas",
    "Cukup Jelas",
    "Sangat Jelas",
  ],
  kecepatanLayanan: [
    "Sangat Lambat",
    "Lambat",
    "Cukup Cepat",
    "Cepat",
    "Sangat Cepat",
  ],
};

export const INITIAL_FORM_DATA = {
  karyawanNama: "",
  nama: "",
  umur: "",
  jenisKelamin: "",
  tanggalKunjungan: "",
  layanan: "",
  kebersihan: "",
  keramahan: "",
  kejelasanInformasi: "",
  kecepatanLayanan: "",
  fasilitasRumahSakit: "",
  profesionalisme: "",
  saran: "",
};

const FormConstants = {
  JENIS_KELAMIN_OPTIONS,
  LAYANAN_OPTIONS,
  RATING_LABELS,
  INITIAL_FORM_DATA,
};

export default FormConstants;